import { useRouter } from 'next/router';
import { useState } from 'react';
import useSWR from 'swr';
import { getMostViewedWebContent } from '../../datafetchers/HomePage';
import Loader from '../Loader';
import { GridWrapper } from '../StoreHomePage/BannersGrid/styled';
import Card from './ArticlesAndVideos/Card';
import {
  SimilarVideoSection,
  SimilarVideoTitle,
} from './ArticlesAndVideos/styled';
import { getTitle } from './common';
import HindiParentingPagination from './HindiParentingPagination';

export default function HindiParentingArticles(props) {
  const { articleData, params, pageValue, lang } = props;

  const [showLoader, setShowLoader] = useState(false);
  const router = useRouter();
  const { data, error, mutate } = useSWR(
    `${lang}names_${pageValue}`,
    () => {},
    {
      fallbackData: articleData,
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
    },
  );

  const fetchData = (selected) => {
    setShowLoader(true);
    params.skip = selected * params.limit;
    getMostViewedWebContent(params, lang).then((response) => {
      const newData = response;
      mutate(newData, false);
      const newParams = new URLSearchParams(window.location.search);
      let key;
      switch (lang) {
        case 'hi':
          key = 'hipage';
          break;
        case 'bn':
          key = 'bnpage';
          break;
        case 'ta':
          key = 'tapage';
          break;
        case 'te':
          key = 'tepage';
          break;
      }
      newParams.set(key, selected);
      router.replace(window?.location?.pathname + '?' + newParams, undefined, {
        shallow: true,
        scroll: false,
      });
      setShowLoader(false);
    });

    setTimeout(() => {
      var upperElement = document.getElementById('topCarousel');
      var upperElementpos = upperElement.getBoundingClientRect();
      window.scroll(0, upperElementpos.height - 85);
    }, 800);
  };
  return (
    <>
      <GridWrapper>
        <div>
          <SimilarVideoTitle hindiArticle>{getTitle(lang)}</SimilarVideoTitle>
        </div>
        <SimilarVideoSection>
          {data?.data?.map((data, index) => {
            return (
              <Card
                primaryTagId={data?.primary_tag_id}
                index={index}
                cardData={data?.content}
                contentType={data?.content_type}
                heading={data?.heading}
                key={index}
                lang={lang}
              />
            );
          })}
        </SimilarVideoSection>
        <HindiParentingPagination
          count={JSON.parse(data?.count)}
          limit={params.limit}
          pageValue={pageValue}
          fetchData={fetchData}
          lang={lang}
        />
      </GridWrapper>
      {showLoader && <Loader />}
    </>
  );
}
